import { RestUrl } from "../common/cyan.types";

export class MsaUrl {
  public static waken: RestUrl = ["GET", "/msa/waken"];
}
